// DS: i4.10
import React from 'react';
import IconWrap, { Props } from '../../IconWrap';

const Check: React.FC<Props> = props => {
  return (
    <IconWrap {...props}>
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="24"
        height="24"
        fill="none"
        viewBox="0 0 24 24"
      >
        <path
          fillRule="evenodd"
          d="M3.592 15.931a.788.788 0 01-.192-1.095.783.783 0 011.092-.193l5.14 3.61L19.082 4.72a.783.783 0 011.092-.193c.355.249.441.74.193 1.095L10.468 19.8a.783.783 0 01-1.093.193l-5.783-4.06z"
          clipRule="evenodd"
        ></path>
      </svg>
    </IconWrap>
  );
};
Check.displayName = 'Check';

export default Check;
